export enum LEGAL_DOCUMENT_TYPES {
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  SCHOOL_RULES = 'SCHOOL_RULES',
  AI_PACT = 'AI_PACT',
}

export enum LEGAL_DOCUMENTS_VERSION_TYPES {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
}

/** Mongoose model metadata owned by the legal-document bounded context. */
export const LEGAL_DOCUMENT_MODEL = {
  MODEL_NAME: 'LegalDocument',
  COLLECTION_NAME: 'LegalDocuments',
} as const;
